import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

export async function getEstados({commit, state}) {
  await $http.get('controles/8')
    .then((response) => {
      commit('cargarEstados', response.data);
    })
    .catch((error) => {

    });
}

export async function getExisteNoExiste({commit, state}) {
  await $http.get('controles/15')
    .then((response) => {
      commit('CargarExisteNoExiste', response.data);
    })
    .catch((error) => {

    });

}

export async function guardaProducto({commit, state}) {

  await $http.post('adm_productos/crear', state.selectedProduct)
    .then((response) => {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
      state.error = false;
      commit('guardaProducto', state);
      state.selectedProduct.Idproducto = response.data.Idproducto;
      this.getProducto(state.selectedProduct.Idproducto);
    })
    .catch((error) => {

      //commit('productError', error.message)
    });
}

export async function actualizaProducto({commit, state, rootState}, id) {


  await $http.put(`adm_productos/editar/${id}`, state.selectedProduct)
    .then((response) => {

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
      state.error = false;
      this.getProducto(state.selectedProduct.Idproducto);
    })
    .catch((error) => {

      //commit('productError', error.message)
    });
}

export async function getProductos({commit, state, dispatch}) {

  const parametros = {params: state.filtro};

  commit('dashboard/load', true, {root: true});
  await $http.get('adm_productos_rpq', parametros)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setProductos', response.data);
      //agrega campos extra desde aca.
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      //commit('productError', error.message)
    });
}

/**
 * Obtener fabricantes desde el back
 */
export async function obtenerFabricantes({commit, state}, nombre) {

  if (!state.cargando_datos_select && nombre && nombre.length > 2) {
    commit('establecerCargandoDatosSelect', true);

    let parametros = {
      params: {
        nombre: nombre
      }
    };

    await $http.get('/fabricantes', parametros)
      .then((response) => {
        commit('establecerCargandoDatosSelect', false);
        commit('setFabricantes', response.data.fabricantes);
      })
      .catch(() => {
        commit('establecerCargandoDatosSelect', false);
      });
  }
}

export async function getProductosEmpresa({commit, state}, requestParameters = {params: state.filtro}) {
  await $http.get('productos', requestParameters)
    .then((response) => {

      commit('setProductos', response.data);
    })
    .catch((error) => {

      //commit('productError', error.message)
    });
}

export async function getEmpresaFiltro({commit, state}, query) {

  await $http.get('/empresas/lista', {params: {nombre: query}})
    .then((response) => {

      commit('setListaEmpresa', response.data);
      state.error = false;
    })
    .catch((error) => {
      commit('mensajeError', error.message);
    });
}

export async function getAreasFiltro({commit, state}, query) {
  await $http.get(`empresas/areas/${state.filtro.empresa}`, {params: {nombre: query}})
    .then((response) => {

      commit('setListaAreas', response.data);
      state.error = false;
    })
    .catch((error) => {
      commit('mensajeError', error.message);
    });
}

export async function getBasesFiltro({commit, state}, query) {
  await $http.get(`empresas/bases/${state.filtro.empresa}`, {params: {nombre: query}})
    .then((response) => {
      commit('setListaBases', response.data);
      state.error = false;
    })
    .catch((error) => {
      commit('mensajeError', error.message);
    });
}

export async function getCamposPersonalizados({commit, state}) {
  await $http.get(`adm_productos/campos_personalizados/${state.filtro.empresa}`)
    .then((response) => {
      commit('setListaCampos', response.data);
      state.error = false;
    })
    .catch((error) => {
      commit('mensajeError', error.message);
    });
}

export async function descargarAdjunto({commit, state}, id) {
  await $http.get(`adm_productos/adjuntos/download/${id}`)
    .then((response) => {
      state.error = false;
    })
    .catch((error) => {
      commit('productError', error.message);
    });
}

export async function getProductoTarjeta({commit, state}, id) {
  await $http.get(`adm_productos/${id}`)
    .then((response) => {

      commit('setProducto', response.data);
    })
    .catch((error) => {
      commit('productError', error.message);
    });
}

export async function setPagePagination({commit, dispatch, state}, page) {
  commit('setPage', parseInt(page));
  //  if (state.esAdmin) {
  await dispatch('getProductos');
  /*  }
   if (state.esEmpresa) {
       dispatch('getProductosEmpresa')
   } */
}

/**
 * Método para obtener los campos personalizados en la pantalla de empresas.
 *
 * @param {*} param0
 */
export async function getEmpresasPersonalizados({commit, state, rootState}) {

  var producto = rootState.productos.selectedProduct.id;
  if (producto == '') {
    producto = rootState.productos.selectedProduct.Idproducto;
  }

  var IdProducto = parseInt(producto);
  await $http.post(`adm_productos/campos_personalizados/${IdProducto}`)
    .then((response) => {
      commit('setCamposPersonalizados', response.data.campos);

    })
    .catch((error) => {

    });
}

/**
 * Método para obtener las bases y areas asignadas al producto químico.
 *
 * @param {*} param0
 * @param {*} id_empresa id de la generales.
 */
export async function getUbicacionEmpresa({commit, state, dispatch}, datos) {
  let params = {
    params: {
      esEmpresa: datos.esEmpresa
    }
  };

  await $http.get(`adm_productos/ubicaciones/${datos.producto}/${datos.empresa}`, params)
    .then(async (response) => {
      commit('setUbicaciones', response.data.data);
      await dispatch('getUbicacionEmpresaContratistas', datos);
    });
}

/**
 * Método para obtener las bases y areas asignadas al producto químico.
 *
 * @param {*} param0
 * @param {*} id_empresa id de la generales.
 */
export async function getUbicacionEmpresaContratistas({commit, state}, datos) {
  try {

    await $http.get(`adm_productos/ubicaciones_contratistas/${datos.producto}/${datos.empresa}`, state)
      .then((response) => {
        commit('setUbicacionesContratistas', response.data);
      });

  } catch (e) {
    commit('dashboard/load', false, { root: true });
  }
}

/**
 * Método para obtener las bases y áreas de la pantalla de empresas.
 *
 * @param {*} param0
 */
export async function getBasesAreasEmpresa({commit, state, rootState}) {

  var producto = rootState.productos.selectedProduct.id;
  if (producto == '') {
    producto = rootState.productos.selectedProduct.Idproducto;
  }

  var IdProducto = parseInt(producto);

  await $http.get(`empresas/getBasesAreasEmpresas/${IdProducto}`)
    .then((response) => {

      commit('setBasesAreas', response.data.data);

    })
    .catch((error) => {

    });
}

/**
 * Método para obtener la información de CAS de la pantalla de empresas.
 *
 * @param {*} param0
 */
export async function getListadoCas({commit, state, rootState}, id) {
  await $http.get(`adm_productos/nocas/ver/${id}`)
    .then((response) => {
      commit('setCasEmpresa', response.data);
    })
    .catch((error) => {

    });
}

export async function guardarProductosMasivoRpq({commit, state, rootState}) {
  var empresa = rootState.empresa.selectedEmpresa.id;

  await $http.post(`adm_productos/rpq/producto/masivo/${empresa}`, state.rpqMasivoProductos)
    .then((response) => {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.message,
        showConfirmButton: false,
        timer: 3000,
      });
      commit('limpiarRpqMasivoProductos');
    })
    .catch((error) => {

    });
}

export async function guardaRpqProducto({commit, state, rootState}, data) {

  commit('dashboard/load', true, {root: true});

  var empresa = rootState.empresa.selectedEmpresa.id;

  await $http.post(`adm_productos/rpq/producto/${empresa}`, data)
    .then(async (response) => {
      commit('dashboard/load', false, {root: true});
      if (response.data.extras.superado === true) {
        await Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        await Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Método para obtener la información de CAS de la pantalla de empresas.
 *
 * @param {*} param0
 */
export async function getCodigoQR({commit, state, rootState}) {

  var empresa = rootState.empresa.selectedEmpresa.id;
  var producto = rootState.productos.selectedProduct.id;
  if (producto == '') {
    producto = rootState.productos.selectedProduct.Idproducto;
  }
  let data = {
    id_empresa: empresa
  };

  await $http.get(`codigo/${producto}/1`, data)
    .then((response) => {
      commit('setCodigoQR', response.data);
    })
    .catch((error) => {

    });
}

/**
 * @param state
 * @param commit
 * @returns {Promise<void>}
 */
export async function listarFabricantes({state, commit}) {

  if (!state.fabricantes.length) {
    let params = {
      params: {
        paginate: false,
        omitir_ocultos: state.esEmpresaContratista
      }
    };

    await $http.get('/fabricantes', params)
      .then((response) => {
        commit('setFabricantes', response.data.fabricantes);
      })
      .catch((error) => {
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Error al cargar fabricantes: ' + error,
          showConfirmButton: false,
          timer: 1500
        });
      });
  }
}

export async function asignarTodosLosProductos({commit, state, rootState, dispatch}, tipo) {

  let texto = '';

  switch (tipo) {
    case 'asignado':
      texto = '<p>¿Está seguro de marcar TODOS los productos como <span class="font-weight-bold text-uppercase">ASIGNADO RPQ</span>?</p>';
      break;
    case 'pago':
      texto = '<p>¿Está seguro de marcar TODOS los productos como <span class="font-weight-bold text-uppercase">CARACTERIZADO</span>?</p>' +
        '<p>Este proceso marcará inicialmente TODOS los productos como <span class="font-weight-bold text-uppercase">ASIGNADO RPQ</span>' +
        '<p class="text-danger">Este proceso puede tardar dependiendo de la cantidad de productos</p>';
      break;
  }

  await Swal.fire({
    title: 'Proceso masivo',
    html: texto,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    cancelButtonText: 'Cancelar',
    confirmButtonText: 'Si, Marcar'
  }).then(async (result) => {
    if (result.value) {
      const id_empresa = rootState.empresa.selectedEmpresa.id;

      const parametros = {
        tipo,
        id_empresa
      };

      commit('dashboard/load', true, {root: true});

      await $http.post(`adm_productos/rpq/todos-productos/${id_empresa}`, parametros)
        .then(async (response) => {
          await dispatch('getProductos');
          commit('dashboard/load', false, {root: true});
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Muy bien!',
            text: 'Proceso masivo completado con exito',
            showConfirmButton: false,
            timer: 3000,
          });
        })
        .catch((error) => {
          commit('dashboard/load', false, {root: true});
        });
    }
  });
}



/**
 * Crear o actualizar productos a ubicaciones
 * @param payload: company_id, locations, products_ids
 * @autor Paul Valencia
 */
export async function addLocationsToProducts({commit}, payload) {
  try {
    commit('dashboard/load', true, {root: true});
    const response = await $http.post(`adm_products/rpq/assign-locations-products`, payload);
    return response.data;
  } catch (error) {
    if (error.message) {
      await Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.message,
        showConfirmButton: false,
        timer: 2000
      });
    }
  } finally {
    commit('dashboard/load', false, {root: true});
  }
}

/**
 * Obtener los productos RPQ para Diligenciados-
 *
 * @param Object acciones y estado.
 */
export async function getProductsIndexRpq({commit, state}) {
  commit('dashboard/load', true, {root: true});

  await $http.get('products-rpq', { params: state.filtro })
    .then(({data: response}) => commit('setProductos', response.data))
    .catch((error) => {
      if (this.$vue.$alertErrorsCallback(error)) return;
      this.$vue.$alertError(error.message);
    })
    .finally(() => commit('dashboard/load', false, {root: true}))
}
